<script>
  import "carbon-components-svelte/css/g90.css";
  import Tailwind from "../Tailwind.svelte";






</script>
<Tailwind/>


    <div class="py-8 px-48 leading-8 font-rown">
        <h1><strong>Account Deletion Guide</strong></h1>
        <p>Need to delete your Gambit account? Follow these quick and easy steps on our mobile app. It's simple and straightforward.</p>
        <h2><strong>Step-by-Step Instructions:</strong></h2>
        <ol>
            <li><strong>Go to Your Profile</strong><br>
            Open the Gambit mobile app. Tap on the 'Profile' icon, located at the bottom right of the screen.</li>
            <li><strong>Delete Your Account</strong><br>
            In your profile, find and tap on the 'Delete Account' option. Confirm the deletion when prompted.</li>
        </ol>
    </div>


